/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import './polyfills'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import { App } from './app/App'
import { router } from './app/providers/router-provider'
import { posthogInit } from './shared/lib/posthog/posthog'
import { POSTHOG_KEY } from './shared/constants/env'
import './shared/lib/i18n'

posthogInit(POSTHOG_KEY)

router.subscribe('onLoad', () => {
  posthog.capture('$pageview')
})

const elem = document.getElementById('root')!
const app = (
  <StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </StrictMode>
)

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem))
  root.render(app)
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app)
}
